"use strict";

const local ='http://localhost:3000'
const cpanel = 'https://iacop.com.mx'

exports.url = cpanel + '/api';

const CONSTANTS = {
    GETTING_INFO : "GET_INFO",
    GET_INFO_SUCCESS : "GET_INFO_SUCCESS",
    GETTING_IMG : "GET_IMG",
    GET_IMG_SUCCESS : "GET_IMG_SUCCESS",
    SET_HISTORY_OPTION : "SET_HISTORY_OPTION",
    SET_ADDED : "SET_ADDED",
    SET_STATUS : "SET_STATUS",
    GETTING_MSG : "GETTING_MSG",
    GET_MSG : "GET_MSG",
    ERROR_MSG: "Ha ocurrido un error al intentar realizar la solicitud",
    SUCCESS_MSG: "Mensaje enviado con éxito",
    ERROR_STATUS: "error",
    SUCCESS_STATUS: "success",
    ERROR_INPUTS: "Campos no válidos",
    SUCCES_SUSCRIPTION: "Suscripción exitosa",
    SET_TOKEN: "SET_TOKEN", 
    SET_IDENTITY: "SET_IDENTITY", 
    GET_INFO_IDENTITY: "GET_INFO_IDENTITY",
    CLEAN_VALUE: "CLEAN_VALUE",
    EMAIL_FORMAT: "Email formato no valido",
}
exports.CONSTANTS = CONSTANTS;

function getErrorMessage(message) {
    if(!message) return createError(CONSTANTS.ERROR_MSG);

    if (Array.isArray(message)) {
      const stringErrors = message.map(err => err.msg).join(', ')
      return createError(stringErrors, message)
    } else if (typeof message === 'string') {
      return createError(message);
    } else {
      return createError(CONSTANTS.ERROR_MSG);
    }
  }

function createError(message_error, detail = []){

    return  {
        success: false,
        status: CONSTANTS.ERROR_STATUS,
        code: 500,
        message: message_error,
        data: null,
        detail
    }
}

exports.getErrorMessage = getErrorMessage;


function roundNum( value ) {
  if(typeof value !== 'number') return 0
  return Math.round(value * 100) / 100
}

exports.roundNum = roundNum;

const costoEnvio = 200
exports.costoEnvio = costoEnvio


function crearSlugTitle(value){
  if(!value) return ''
  return value
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Elimina acentos
      .toLowerCase()
      .replace(/[^\w\s-]/g, '') // Elimina símbolos excepto guiones y espacios
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
}

exports.crearSlugTitle = crearSlugTitle